// Use same-origin relative URL when REACT_APP_BACKEND_URL is not set at build time.
// This keeps local/preview builds (which set the env var) and production (same-origin) both working.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_mymoney-9/artifacts/rddg30v3_Blue%20.png";

export { BACKEND_URL, API, LOGO_URL };
